// extracted by mini-css-extract-plugin
export default {"button":"MenuButton_button__pSq9K"};